
export const isStaging = () => window.location?.host==="auth.tecnichenuove.it"